import './notifications.scss';

import isEmpty from 'lodash/isEmpty';
import { arrayOf, bool, func } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import Loading from '../../generic/Loading';
import { commentShape } from '../../prop-types';
import Notification from '../Notification';

function Notifications({
  notifications,
  hasMoreNotifications,
  onLoadMore,
  isLoading,
}) {
  return (
    <div>
      {isEmpty(notifications) && !isLoading ? (
        <div className="p-3">You’re up to date!</div>
      ) : (
        <ul className="list-unstyled c-notifications">
          {notifications.map(n => (
            <li className="c-notifications__item border-bottom" key={n.id}>
              <Notification model={n} />
            </li>
          ))}
          {isLoading ? <Loading className="c-notifications-loader" /> : null}
          {hasMoreNotifications && !isLoading ? (
            <Button
              disabled={isLoading}
              onClick={onLoadMore}
              className="c-notifications__load_more"
              color="link"
            >
              Load older notifications
            </Button>
          ) : null}
        </ul>
      )}
    </div>
  );
}

Notifications.propTypes = {
  notifications: arrayOf(commentShape),
  hasMoreNotifications: bool.isRequired,
  onLoadMore: func.isRequired,
  isLoading: bool.isRequired,
};

Notifications.defaultProps = {
  notifications: [],
};

export default Notifications;
